<template lang="pug">
	.app-core--rating-control.flex-row.align-center.space-small(:style="{ '--size': `${this.size}px` }", @mouseout="clearMouseover")
		.star(v-for="(key, idx) in counter", :key="idx", :class="{ active: mouseOverIdx === null && idx < value || (mouseOverIdx !== null && idx <= mouseOverIdx), focused: mouseOverIdx === idx, selected: value - 1 === idx }", 
			@mouseover="() => { mouseOverIdx = idx; mouseOut = false; }" @mouseout="mouseOut = true", @click="setValue(idx + 1)")
			.icon-holder(:data-number="idx + 1", :style="{ '--font-size': `${Math.max(6, parseInt(size/3))}px`}")
				fas(icon="star")
</template>

<script>
import _ from 'lodash';
import VueTypes from 'vue-types';

export default {
	props: {
		value: VueTypes.number.def(5),
		base: VueTypes.number.def(10),
		size: VueTypes.number.def(12)
	},
	components: {  },
	data() {
		return {
			mouseOverIdx: null,
			mouseOut: false
		}
	},
	watch: {
	},
	computed: {
		counter() {
			return new Array(this.base);
		}
	},
	mounted() {
		if (__DEBUG__)
			window.ratingControl = this;

		this.$clearMouseover = _.debounce(() => {
			if (this.mouseOut) {
				this.mouseOverIdx = null;
			}
		}, 40, {
			leading: false,
			trailing: true
		});
	},
	destroyed() {
		delete this.$clearMouseover;
	},
	methods: {
		clearMouseover() {
			this.$clearMouseover();
		},
		setValue(val) {
			this.$emit('update:value', val);
			this.$emit('value-changed', val);
		}
	}
};
</script>
<style lang="scss">
	@import "main/themes/generated/variables.base.scss";
	.app-core--rating-control {
		.star {
			font-size: var(--size);
			color: rgba(0,0,0,0.1);
			cursor: pointer;
			position: relative;

			&.active {
				color: $base-accent;
			}

			.icon-holder {
				transition: 0.3s;
				pointer-events: none;
			}

			&.focused, &.selected {
				.icon-holder {
					transform: scale(1.5) translateY(-1px);
					height: 100%;

					&:after {
						content: attr(data-number);
						position: absolute;
						top: 50%;
						left: 0%;
						color: #fff;
						width: 100%;
						text-align: center;
						font-size: var(--font-size);
						transform: translateY(-50%);
					}
				}
			}

			&.focused {
				.icon-holder {
					transform: scale(2) translateY(-2px);
				}
			}
		}
	}
</style>
